// ui
import { Typography, Modal, Box } from "@mui/material";
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";
import { PO_MODAL_SX, PO_MODAL_SX_SP } from "../lib/poModalFrame";

interface RequestLoadingModalProps {
  onModal: boolean;
}

export function RequestLoadingModal(props: RequestLoadingModalProps) {
  const { onModal } = props;
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const style = isSmartPhone ? PO_MODAL_SX_SP : PO_MODAL_SX;
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} data-testid="request-loading-modal">
        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
          {/* catalog #26 po-spinner: 32px border-spinner */}
          <span className="po-spinner" data-testid="loading-spinner" />
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 1, mb: 2 }}>
          <Box>
            システムが更新されています。
            <br />
            「更新ボタン」もしくは「F5」を押して画面を更新してください。
          </Box>
        </Typography>
      </Box>
    </Modal>
  );
}
